import React from "react";
import { Link } from "react-router-dom";

const CardOne = (props) => {
  return (
    <>
      <Link to={props.url}>
        <div className="card border">
          <div className="ic">{props.icon}</div>
          <div className="titl">
            <p>{props.title}</p>
            <small>{props.subTitle}</small>
          </div>
          {/* <Link to={props.url}>View</Link> */}
        </div>
      </Link>
    </>
  );
};

export default CardOne;
